// extracted by mini-css-extract-plugin
export default {"row":"Header_row__+ORD2"};